<script>

import { Doughnut } from 'vue-chartjs'
import store from 'vuex-store'
import urlApi from '../../../../router/urlApi'
import Vue from 'vue'

let palette = store.getters.palette

export default {
  extends: Doughnut,
  data () {
    return {
      chartData: {
        labels: ['Faltas'],
        datasets: [{
          backgroundColor: [palette.warning],
          data: [0]
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: palette.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 15,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 15,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false,
        fontSize: 25
      }
    }
  },
  async mounted () {
    await Vue.http.get(urlApi + '/ead/profile').then((response) => {
      this.chartData.datasets[0].data[0] = response.body.aulas_praticas.faltas_aulas_praticas + response.body.aulas_teoricas.faltas_aulas_teoricas
    })
    this.renderChart(this.chartData, this.options)
  }

}
</script>
